import { z } from 'zod';

export const requestSublabelFormSchema = z.object({
  name: z.string().trim().min(1).max(200),
  notes: z.string().max(250).optional(),
  parentLabel: z.object({
    value: z.string(),
    label: z.string(),
  }),
});

export type RequestSublabelFormSchema = z.infer<
  typeof requestSublabelFormSchema
>;
